import { render, staticRenderFns } from "./ReportConexion.vue?vue&type=template&id=2f2576b7&scoped=true"
import script from "./ReportConexion.vue?vue&type=script&lang=ts"
export * from "./ReportConexion.vue?vue&type=script&lang=ts"
import style0 from "./ReportConexion.vue?vue&type=style&index=0&id=2f2576b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2576b7",
  null
  
)

export default component.exports